import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "../../services/i18next";
import Layout from "../layout/Layout";
import exImage1 from "../assets/ex.image1.jpg";

function Exhibitions() {
  const { t } = useTranslation();

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage) {
      i18next.changeLanguage(storedLanguage);
    }
  }, []);

  return (
    <Layout>
      <div className="py-12 px-6 md:px-12 lg:px-20 bg-neutral-50 text-gray-700">
        <div className="text-center my-20">
          <h1 className="text-3xl md:text-4xl">{t("exhibitionsTitle")}</h1>
          <hr className="w-[130px] md:w-[250px] mx-auto mt-2 border-gray-400" />
          <p>{t("byDusan")}</p>
        </div>

        <div className="max-w-6xl mx-auto mb-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div className="bg-white p-8 rounded shadow-md h-full flex flex-col justify-between">
            <h2 className="text-xl mb-4">{t("exhibitionTitle1")}</h2>
            <div>
              <p className="mb-2">
                <span className="text-gray-400 text-sm">{t("date")}</span>{" "}
                {t("exhibitionDate")}
              </p>
              <p className="mb-2">
                <span className="text-gray-400 text-sm">{t("opening")}</span>{" "}
                18:00 h
              </p>
              <p className="mb-2">
                <span className="text-gray-400 text-sm">{t("location")}</span>{" "}
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Gallery+Singidunum+Knez+Mihailova+40+Belgrade"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:underline"
                >
                  {t("exhibitionLocation")}
                </a>
              </p>
            </div>
            <div>
              <p className="mb-2 font-medium">{t("exhibitionsNote")}</p>

              <p className="text-sm">{t("exhibitionsNote1")}</p>
            </div>
          </div>

          {/* Images */}
          <div className="grid grid-cols-1 gap-6">
            <img
              src={exImage1}
              alt="Watercolor Artwork 1"
              className="w-full h-auto object-cover rounded shadow"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Exhibitions;
